/**
 *
 * Asynchronously loads the component for SignUpPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
